const style = {
  marginTop30: {
    marginTop: '30px',
  },
};

export default style;
